import React, { useEffect, useState } from "react";
import { Grid, Typography } from "@mui/material";
import LabelButton from "../../components/reusable-components/buttons/LabelButton";
import CheckIcon from "@mui/icons-material/Check";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

const commonTypographyStyles = {
  fontFamily: "Lato",
  fontStyle: "normal",
  fontWeight: 700,
  lineHeight: "normal",
};

const primaryTypographyStyles = {
  ...commonTypographyStyles,
  color: "var(--Primary-500, #16124C)",
};

export default function BotDetection({
  botCheckPassed,
  setBotCheckPassed
}) {
  const [botCheckFinished, setBotCheckFinished] = useState(false);
  const [botResultText, setBotResultText] = useState("");

  useEffect(() => {
    if (botCheckFinished) {
      if (!botCheckPassed) {
        setBotResultText(
          <Grid
            sx={{
              width: "100%",
              height: "17px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: "5px",
            }}>
            <ErrorOutlineIcon
              sx={{ color: "var(--Errors-500, #C30930)", fontSize: "20px" }}
            />
            <Typography
              sx={{
                ...primaryTypographyStyles,
                color: "var(--Errors-500, #C30930)",
                fontSize: 13,
              }}>
              We were unable to verify your account. Please try again later or
              contact support for help.
            </Typography>
          </Grid>
        );
      } else {
        setBotResultText(
          <Grid
            sx={{
              width: "100%",
              height: "17px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: "5px",
            }}>
            <CheckIcon
              sx={{ color: "var(--Tertiary-500, #00A6FF)", fontSize: "20px" }}
            />
            <Typography
              sx={{
                ...primaryTypographyStyles,
                color: "var(--Tertiary-500, #00A6FF)",
                fontSize: 14,
              }}>
              I’m not a robot
            </Typography>
          </Grid>
        );
      }
    }
  }, [botCheckPassed, botCheckFinished]);

  const botVerification = async () => {
    try {
      await new Promise((resolve) =>
        window.grecaptcha.enterprise.ready(resolve)
      );
      const token = await window.grecaptcha.enterprise.execute(
        process.env.REACT_APP_RECAPTCHA_SITE_KEY,
        { action: "submit" }
      );

      if (token) {
        const res = await fetch("/auth/verify-recaptcha", {
          method: "POST",
          body: JSON.stringify({ token }),
          headers: { "Content-Type": "application/json" },
        });

        const success = res.ok;
        const data = success ? await res.json() : null;

        // Ensure both states are set before triggering UI update
        setBotCheckPassed(success);
        setBotCheckFinished(true);

        if (success) {
          return data.riskScore;
        } else {
          console.error("Failed to verify reCAPTCHA Enterprise");
        }
      }
    } catch (err) {
      console.error("reCAPTCHA Enterprise error:", err);
      setBotCheckPassed(false);
      setBotCheckFinished(true);
    }

    return null;
  };

  // run the bot verification when the component mounts
  useEffect(() => {
    const runBotVerification = async () => {
      const riskScore = await botVerification();
      if (riskScore && riskScore >= 0.5) {
        setBotCheckPassed(true);
      } else {
        setBotCheckPassed(false);
      }
    };
    runBotVerification();
  }, []);

  return (
    <>
      {/* bot detection result area */}
      {botCheckFinished && (
        <Grid
          item
          sx={{
            width: "100%",
            height: "60px",
          }}>
          {botCheckPassed ? (
            <LabelButton
              type="tertiary"
              variant="contained"
              text={botResultText}
              disabled={true}
              disableButtonStyle={{
                color: "#00A6FF",
                backgroundColor: "#EBF8FF",
                opacity: null,
              }}
            />
          ) : (
            <LabelButton
              type="error"
              variant="text"
              text={botResultText}
              disabled={true}
            />
          )}
        </Grid>
      )}
    </>
  );
}
